import Head from 'next/head';

export default function Header({
  chilren,
  title = '',
}: {
  chilren?: JSX.Element;
  title?: string;
}): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      {chilren}
    </Head>
  );
}
